// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cIkLjGE5_r06uG7_Q4yq{background:var(--border-neutral-tertiary);border-radius:6px;justify-content:space-between;align-items:center;margin-left:8px;margin-right:8px;padding:2px 2px 2px 4px;display:flex}.PphnstYHwaoFsZ7XLOZx{grid-template-columns:max-content auto;gap:8px;margin-right:10px;display:grid}.Yfw69SKREh4enQzho6Hi{background:var(--gray-50);border-radius:4px;justify-content:center;align-items:center;padding:3.5px 8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `cIkLjGE5_r06uG7_Q4yq`,
	"left": `PphnstYHwaoFsZ7XLOZx`,
	"edit": `Yfw69SKREh4enQzho6Hi`
};
export default ___CSS_LOADER_EXPORT___;
